// @flow

import { action } from "mobx";

import Store from "app/stores/Store";

import VideoService from "app/services/VideoService";

class VideoSearchStore extends Store {
    @action.bound resolve(url: string): Promise<*> {
        return VideoService.resolveByUrl(url);
    }
}

export default new VideoSearchStore();



// WEBPACK FOOTER //
// ./src/app/stores/VideoSearchStore.js